module.exports = __webpack_public_path__ + "static/media/bg.58499241.png";